import { ArtefactKind } from "@/services/backend/artefacts/kind";
import {
  Binoculars,
  ClipboardList,
  FlaskRound,
  PackageOpen,
  Shapes,
} from "lucide-react";
import { cn } from "@/shared/lib/utils";

export interface ArtefactIconProps {
  artefactKind: ArtefactKind;
  className?: string;
}

export const ArtefactIconDelivery = PackageOpen;
export const ArtefactIconDocumentation = FlaskRound;
export const ArtefactIconCounting = Binoculars;
export const ArtefactIconDifferentiation = Shapes;
export const ArtefactIconInspection = ClipboardList;

export function ArtefactIcon({
  artefactKind,
  className = "",
}: ArtefactIconProps) {
  switch (artefactKind) {
    case ArtefactKind.Delivery:
      return <ArtefactIconDelivery className={cn("h-5 w-5", className)} />;
    case ArtefactKind.Documentation:
      return <ArtefactIconDocumentation className={cn("h-5 w-5", className)} />;
    case ArtefactKind.Counting:
      return <ArtefactIconCounting className={cn("h-5 w-5", className)} />;
    case ArtefactKind.Differentiation:
      return (
        <ArtefactIconDifferentiation className={cn("h-5 w-5", className)} />
      );
    case ArtefactKind.Inspection:
      return <ArtefactIconInspection className={cn("h-5 w-5", className)} />;
    default:
      return <span>{artefactKind}</span>;
  }
}
